import devData from "../devData";
import { FORM_DATA } from "../state/constants/FormData";
import { FormData } from "../types";

declare const rawFormData: string;

const getFormData = () => {
  const { NODE_ENV } = process.env;
  let data =
    NODE_ENV !== "production" && NODE_ENV !== "ci" ? devData : FORM_DATA;

  if (typeof rawFormData !== "undefined") {
    try {
      data = JSON.parse(rawFormData) as FormData;
    } catch (err) {
      console.log(err);
    }
  }
  return data;
};

export default getFormData;
